// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_quill_quill_js":"e05dc7031c6756dd","polyfills-dom":"fcdb9761748daa59","polyfills-core-js":"fdfe55056edf324b","node_modules_profabric_web-components_dist_esm_pf-button_6_entry_js":"66c3dd9369562f67"}[chunkId] + ".js";
};